import axios from 'axios';
let aliyunoss = function (config) {
    this.accessid = '';
    this.accesskey = '';
    this.host = '';
    this.policyBase64 = '';
    this.signature = '';
    this.callbackbody = '';
    this.filename = '';
    this.key = '';
    this.expire = 0;
    this.now = 0;
    this.issynctime = false;
    this.serverurl = config.url;
    this.token = config.token || this.randomid();
}
aliyunoss.prototype = {
    send_request: function (callback, config) {
        return new Promise((resolve, reject) => {
            var that = this;
            let config = {
                headers: { 'Content-Type': 'application/json' }
            };  //添加请求头
            console.log("发送请求前")
            console.log(that.serverurl)
            axios.post(that.serverurl,
                {
                    CallbackUrl: "http://tqmzos.mbj100.com/open/oss/callback",
                    Host: "https://oss.ypwsd.com",
                    DirName: "zg/",
                    Key: that.token,
                }, config)
                .then(response => {
                    resolve(response.data)
                    callback(response.data);
                })

        })

    },
    get_signature: function (callback) {
        //可以判断当前expire是否超过了当前时间,如果超过了当前时间,就重新取一下.3s 做为缓冲
        if (this.expire < this.now + 3) {
            var that = this;
            that.cleartimer();
            that.send_request(function (data) {
                //var body = this.send_request();
                if (data && data.Status == 0) {
                    var obj = data.Data;
                    that.host = obj['Host'];
                    that.policyBase64 = obj['Policy'];
                    that.accessid = obj['AccessId'];
                    that.signature = obj['Signature'];
                    that.now = parseInt(obj['SystemTimestamp']);
                    that.expire = parseInt(obj['ExpireTimestamp']);
                    that.callbackbody = obj['Callback'];
                    that.key = obj['DirName'];
                    that.synctime();
                }
                callback();
            }, {
                type: 'post',
                dataType: 'JSON'
            });
        } else {
            callback();
        }
    },
    cleartimer: function () {
        var that = this;
        if (typeof that.intervaler != 'undefined') {
            clearInterval(that.intervaler);
        }
    },
    synctime: function () {
        var that = this;
        that.intervaler = setInterval(function () {
            that.now += 1;
        }, 1000);
    },
    randomid: function () {
        var len = 32;
        var chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
        var maxPos = chars.length;
        var randomid = '';
        for (let i = 0; i < len; i++) {
            randomid += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return randomid;
    },
    //附加参数
    formdataappend: function (postdata, callback) {
        var that = this;
        that.get_signature(function () {
            postdata.append('key', that.key + that.randomid() + '.jpg');
            postdata.append('policy', that.policyBase64);
            postdata.append('OSSAccessKeyId', that.accessid);
            postdata.append('callback', that.callbackbody);
            postdata.append('signature', that.signature);
            postdata.append('token', that.token);

            // console.log(postdata);

            callback();
        });
    },
    formdataappendfile: function (postdata, callback) {
        var that = this;
        that.get_signature(function () {
            // postdata.append('key', that.key + that.randomid() + '.jpg');
            postdata.append('key', that.key + that.randomid() + postdata.fileName);
            postdata.append('policy', that.policyBase64);
            postdata.append('OSSAccessKeyId', that.accessid);
            postdata.append('callback', that.callbackbody);
            postdata.append('signature', that.signature);
            postdata.append('token', that.token);

            // console.log(postdata);

            callback();
        });
    }
}

export default aliyunoss




// WEBPACK FOOTER //
// ./src/assets/script/oss.js